/**
 * MLS-MAILAWAY-ALIGN-001 — shared Mail-Away status vocabulary.
 * Mirrors the Tax STATUS_CONFIG in MultiJurisdictionMailAway.jsx (which is
 * intentionally left untouched). Consumers: MLS Mail-Away today; Tax may
 * adopt later.
 */
import { Mail, CheckCircle, Clock, AlertCircle, XCircle, RotateCcw } from 'lucide-react';

export const MAIL_AWAY_STATUS_CONFIG = {
  not_sent: { label: 'Not Sent', color: 'bg-gray-100 text-gray-600 border-gray-200', icon: Clock },
  pending_send: { label: 'Sent', color: 'bg-blue-50 text-blue-600 border-blue-200', icon: Mail },
  sent: { label: 'Sent', color: 'bg-blue-50 text-blue-600 border-blue-200', icon: Mail },
  confirmed: { label: 'Marked Sent', color: 'bg-green-50 text-green-600 border-green-200', icon: CheckCircle },
  awaiting_response: { label: 'Pending', color: 'bg-amber-50 text-amber-600 border-amber-200', icon: Clock },
  overdue: { label: 'Overdue', color: 'bg-red-50 text-red-600 border-red-200', icon: AlertCircle },
  response_received: { label: 'Received', color: 'bg-green-50 text-green-600 border-green-200', icon: CheckCircle },
  cancelled: { label: 'Cancelled', color: 'bg-red-50 text-red-500 border-red-200', icon: XCircle },
  superseded: { label: 'Resent', color: 'bg-slate-100 text-slate-500 border-slate-200', icon: RotateCcw },
};

export const MAIL_AWAY_ACTIVE = ['pending_send', 'sent', 'confirmed', 'awaiting_response'];

const todayIso = () => new Date().toISOString().slice(0, 10);

// Overdue rule (user decision): the configured Follow-up Date has passed.
export const isPastFollowUp = (request) =>
  !!request?.follow_up_date && String(request.follow_up_date).slice(0, 10) < todayIso();

export const getEffectiveMailAwayStatus = (request) => {
  const status = request?.status || 'not_sent';
  if (MAIL_AWAY_ACTIVE.includes(status) && isPastFollowUp(request)) return 'overdue';
  return status;
};

export const daysPastFollowUp = (request) => {
  if (!isPastFollowUp(request)) return 0;
  const due = new Date(`${String(request.follow_up_date).slice(0, 10)}T00:00:00Z`).getTime();
  const now = new Date(`${todayIso()}T00:00:00Z`).getTime();
  return Math.max(0, Math.round((now - due) / 86400000));
};
